<template>
  <div v-if="!hasSelectedCookies" v-cloak
       class="border rounded border-gray-300 p-4 fixed bottom-4 mx-2 lg:mx-0 lg:right-4 bg-white max-w-lg text-sm max-h-[97%] md:max-h-[90%] overflow-y-auto z-index-9999999999"
  >
    <p class="mt-3 sm:block">
      {{ $t('footer.cookies.introduction') }}
    </p>
    <div class="sm:block">
      <p class="mt-3"
         v-html="$t('footer.cookies.privacyLinkText').replaceAll(':privacyPolicy', privacyPolicyLink)"
      ></p>
      <div class="mt-3">
        <button class="text-white bg-black transition-all hover:bg-blue-500 font-medium mr-3 uppercase py-2 px-6 rounded"
                @click.prevent="submitAcceptedCookies"
        >
          {{ $t('footer.cookies.confirmCookiesSettings') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      acceptedCookies: {
        performance: true,
        analytics: true,
      },
    }
  },

  computed: {
    ...mapGetters('Cookies', {
      hasSelectedCookies: "hasSelectedCookies",
    }),

    privacyPolicyLink() {
      return '<a href="/privacy-policy" target="_blank" class="font-medium">' + this.$t('footer.cookies.privacyPolicy') + '</a>';
    },

    termsLink() {
      return '<a href="/terms-conditions" target="_blank" class="font-medium">' + this.$t('footer.cookies.terms') + '</a>';
    },
  },

  methods: {
    ...mapActions('Cookies', ['setAcceptedCookies']),

    submitAcceptedCookies() {
      this.setAcceptedCookies(this.acceptedCookies);
    },
  },
}
</script>

<style scoped>
.z-index-9999999999 {
  z-index: 9999999999;
}
</style>
